var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"sections":_vm.sections}}),_c('Content'),_c('Footer',{attrs:{"sections":_vm.sections}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }